import { atom } from 'jotai';
import type { ErrorModalProps } from 'components';

export const errorModalAtom = atom<ErrorModalProps | null>(null);
